function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var Resource = /*#__PURE__*/function () {
  function Resource(options) {
    _classCallCheck(this, Resource);
    _defineProperty(this, "status", "loading");
    _defineProperty(this, "fetchStatus", "idle");
    _defineProperty(this, "data", undefined);
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "isCompleted", void 0);
    _defineProperty(this, "_loadFn", void 0);
    _defineProperty(this, "_fetch", null);
    _defineProperty(this, "_executor", null);
    _defineProperty(this, "_destroyed", false);
    var load = options.load;
    this.isCompleted = false;
    this._loadFn = load;
  }

  // _load() {
  //   if (this.status === "success") {
  //     return Promise.resolve(this.data!);
  //   }
  //   return this.fetch();
  // }
  _createClass(Resource, [{
    key: "onSuccess",
    value: function onSuccess(data) {
      if (this._destroyed) {
        this._destroy(data);
        return;
      }
      this.status = "success";
      this.data = data;
      this._executor.resolve(data);
      this.onComplete();
    }
  }, {
    key: "onError",
    value: function onError(reason) {
      if (this._destroyed) {
        return;
      }
      this.status = "error";
      this.error = reason;
      if (this._executor) {
        this._executor.reject(reason);
      }
      this.onComplete();
    }
  }, {
    key: "onComplete",
    value: function onComplete() {
      return this.isCompleted = true;
    }

    // protected execute(): Promise<T> {
    //   let fetch = this._fetch;
    //   if (!this._fetch) {
    //
    //   }
    //   return fetch;
    // }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this._executor) {
        this._executor.reject('cancel');
      }
    }

    // protected abstract onLoad(): Promise<T>;
  }, {
    key: "fetch",
    value: function fetch() {
      var _this = this;
      var fetch = this._fetch;
      if (!fetch) {
        fetch = this._fetch = new Promise(function (resolve, reject) {
          _this._executor = {
            resolve: resolve,
            reject: reject
          };
          _this._loadFn().then(function (data) {
            return _this.onSuccess(data);
          }, function (reason) {
            return _this.onError(reason);
          }).finally(function () {
            _this._executor = null;
            _this._fetch = null;
          });
        });
      }
      return fetch;
    }
  }, {
    key: "load",
    value: function load() {
      if (this.status === 'success') {
        return Promise.resolve(this.data);
      }
      return this.fetch();
    }
  }, {
    key: "get",
    value: function get() {
      switch (this.status) {
        case "error":
          {
            return null;
          }
        case "success":
          {
            return this.data;
          }
        case "loading":
          {
            throw this.fetch();
          }
      }
    }
  }, {
    key: "_destroy",
    value: function _destroy(data) {
      if (data && _typeof(data) === 'object') {
        if ('destroy' in data && typeof data['destroy'] === 'function') {
          data.destroy();
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroy(this.data);
      if (this._executor) {
        this.cancel();
      }
      this.data = undefined;
      this._destroyed = true;
    }
  }]);
  return Resource;
}();